import { LCH_to_sRGB, LCH_to_sRGB_string } from './lch.vendor';

export function lchToRgb(l, c, h) {
  const [r, g, b] = LCH_to_sRGB([l, c, h]);

  return [
    Math.round(r * 255),
    Math.round(g * 255),
    Math.round(b * 255),
  ];
}
export function lchToRgbString(l, c, h) {
  return LCH_to_sRGB_string(l, c, h, 100, true);
}
